<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>修改小程序信息
    </div>
    <div class="content contentBody"
         v-loading="refreshOption"
         element-loading-text="努力刷新中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.4)"
    >
      <div v-if="authorizationInfo">
        <el-row class="listTile">
          <el-col :span="4">
            <div class="grid-content bg-purple listName titleline">基本信息</div>
          </el-col>
          <el-col :span="10">
            <div class="listName"></div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light listName">说明</div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple listName">操作</div>
          </el-col>
        </el-row>
        <el-row class="listTile-line">
          <el-col :span="4">
            <div class="grid-content bg-purple titleline">小程序名称</div>
          </el-col>
          <el-col :span="10">
            <span class="smallTitle">{{authorizationInfo.nick_name?authorizationInfo.nick_name:'暂无数据'}}</span>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">正式发布小程序后，只能通过重新微信认证修改名</div>
            <!--<div class="grid-content bg-purple-light">每个月3次机会, 本月还可修改{{authorizationInfo?3-authorizationInfo.modify_name_count:0}}次-->
            <!--</div>-->
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple editWord" v-if="!authorizationInfo.nick_name">
              <span @click="eidtCompanyName">修改</span>
            </div>
            <div class="grid-content bg-purple editWord" v-else>
              <span @click="eidtCompanyName" v-if="authorizationInfo.nickname_audit!==0">修改</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="listTile-line">
          <el-col :span="4">
            <div class="grid-content bg-purple lineImgBlock titleline">小程序头像 </div>
          </el-col>
          <el-col :span="10">
            <img
                    :src="authorizationInfo.head_image_url?authorizationInfo.head_image_url:'http://mmbiz.qpic.cn/mmbiz/a5icZrUmbV8p5jb6RZ8aYfjfS2AVle8URwBt8QIu6XbGewB9wiaWYWkPwq4R7pfdsFibuLkic16UcxDSNYtB8HnC1Q/0'"
                    width="50" height="50">
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">每个月5次机会, 本月还可修改{{authorizationInfo?5-authorizationInfo.modify_pic_count:0}}次
            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple editWord"><span @click="toggleShow">修改</span></div>
          </el-col>
        </el-row>
        <el-row class="listTile-line">
          <el-col :span="4">
            <div class="grid-content bg-purple cateBodyBox titleline">服务类目</div>
          </el-col>
          <el-col :span="10">
            <div v-if="authorizationInfo.service_cate.length!==0" class="catelistbody-list">
              <div class="catelist-box-line">
                  <span class="smallTitle" v-for="(item,idx) in authorizationInfo.service_cate" :key="idx">
                    {{item.first_name	+ ' -> '+ item.second_name}}
                  </span>
              </div>
            </div>
            <div v-else class="catelistbody-list">
              暂无数据
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">每个月3次机会, 本月还可修改{{authorizationInfo?authorizationInfo.quota:0}}次
            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple editWord"><span @click="eidtCompanyCate">修改</span></div>
          </el-col>
        </el-row>
        <el-row class="listTile-line">
          <el-col :span="4">
            <div class="grid-content bg-purple titleline">小程序功能介绍
            </div>
          </el-col>
          <el-col :span="10">
            <span class="smallTitle">{{authorizationInfo.signature_info?authorizationInfo.signature_info:'暂无数据'}}</span>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">每个月5次机会, 本月还可修改{{authorizationInfo?5-authorizationInfo.modify_signature_count:0}}次
            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple editWord">
              <span @click="companySigntrueFn">修改</span></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <addSettingName :visible.sync="addSttinename" :dialogContent="dialogContent" v-if="addSttinename"
                    @initFn="InitFn"></addSettingName>
    <myUpload field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              :width="144"
              :height="144"
              :headers="headers"
              :url="uploadMedia"
              :params="paramsData"
              img-format="png"></myUpload>
    <miniappPanneEditDialog :visible.sync="companySigntrue" v-if="companySigntrue" :formData="textEdit"
                            @editFrom="submitCompanyInfo"></miniappPanneEditDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import addSettingName from "@/components/dialog/addSettingName.vue";
  import miniappPanneEditDialog from "@/components/dialog/miniappPanneEditDialog.vue";
  import myUpload from 'vue-image-crop-upload';

  export default {
    name: "miniappPannel",
    components: {
      addSettingName,
      miniappPanneEditDialog,
      myUpload
    },
    data() {
      return {
        refreshOption: false,
        authorizationInfo: null,
        addSttinename: false,
        dialogContent: '',
        companySigntrue: false,
        textEdit: '',
        uploadMedia: api.upload_media,
        paramsData: {token: sessionStorage.getItem("token")},
        // 裁剪
        show: false,
        headers: {
          smail: '*_~'
        },
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.company_authorization, {})
            .then(response => {
              if (response.data.code == 0) {
                if (response.data.info.service_cate === '[]') {
                  response.data.info.service_cate = []
                }
                this.authorizationInfo = response.data.info
                this.dialogContent = this.authorizationInfo.nick_name
              } else {
              }
            })
            .catch(response => {
            });
      },
      RefreshFn() {
        this.refreshOption = true
        this.axios
            .post(api.company_refresh, {})
            .then(response => {
              if (response.data.code == 0) {
                this.authorizationInfo = response.data.info
              } else {
              }
              this.refreshOption = false
            })
            .catch(response => {
            });
      },
      eidtCompanyName() {
        if(3-this.authorizationInfo.modify_name_count===0){
          this.$confirm('本月修改次数已达上限，请下月修改?', '提示', {
            confirmButtonText: '确定',
            showCancelButton:false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
          return
        }
        if(this.authorizationInfo.nickname_audit===1){
          this.$confirm('小程序名称正在审核中，不能修改！', '提示', {
            confirmButtonText: '确定',
            showCancelButton:false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
          return
        }
        this.addSttinename = true
      },
      toggleShow() {
        if(5-this.authorizationInfo.modify_pic_count===0){
          this.$confirm('本月修改次数已达上限，请下月修改?', '提示', {
            confirmButtonText: '确定',
            showCancelButton:false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
          return
        }
        this.show = !this.show;
      },
      cropSuccess(imgDataUrl, field) {
        this.imgDataUrl = imgDataUrl;
      },
      cropUploadSuccess(jsonData, field) {
        this.uploadCompanyImg(jsonData)
      },
      cropUploadFail(status, field) {
      },
      uploadCompanyImg(res) {
        let data_ = {
          head_img_media_id: res.media_id,
          x1: 0,
          y1: 0,
          x2: 1,
          y2: 1
        };
        this.axios
            .post(api.company_modify_headimage, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '上传成功',
                });
                this.InitFn();
                this.show = !this.show;
              } else {
              }
            })
            .catch(response => {
            });
      },
      goback() {
        this.$router.go(-1);
      },
      companySigntrueFn() {
        if(5-this.authorizationInfo.modify_signature_count===0){
          this.$confirm('本月修改次数已达上限，请下月修改?', '提示', {
            confirmButtonText: '确定',
            showCancelButton:false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
          return
        }
        this.textEdit = this.authorizationInfo.signature_info
        this.companySigntrue = !this.companySigntrue
      },
      eidtCompanyCate() {
        if(Number(this.authorizationInfo.quota)===0){
          this.$confirm('本月修改次数已达上限，请下月修改?', '提示', {
            confirmButtonText: '确定',
            showCancelButton:false,
            type: 'warning'
          }).then(() => {
          }).catch(() => {
          });
          return
        }
        this.$router.push({name: "miniappPannelCate"});
      },
      submitCompanyInfo() {
        this.InitFn();
      }
    },
  };
</script>
